export default __webpack_public_path__ + "static/media/plusWhite.5ccd6371.svg";